import { faArrowDown, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const DROPDOWN = [
  {
    heading: "Home",
    subHeading1: "Homepage 1",
    subHeading2: "Homepage 2",
    subHeading3: "Homepage 3",
    to1: "/homepage1",
    to2: "/homepage2",
    to3: "/homepage3",
    closeIcon: <FontAwesomeIcon icon={faArrowRight} />,
    downIcon: <FontAwesomeIcon icon={faArrowDown} />,
  },
  {
    heading: "Game Category",
    subHeading1: "Action & Adventure",
    subHeading2: "Sports",
    subHeading3: "Kids and Family",
    to1: "/adventure",
    to2: "/sports",
    to3: "/kids",
    closeIcon: <FontAwesomeIcon icon={faArrowRight} />,
    downIcon: <FontAwesomeIcon icon={faArrowDown} />,
  },
  {
    heading: "Blog",
    subHeading1: "Blog Left",
    subHeading2: "Blog Right",
    subHeading3: "Blog Full Width",
    subHeading4: "Blog Detail",
    to1: "/blogleft",
    to2: "/blogright",
    to3: "/blogfull",
    to4: "/blogdetail",
    closeIcon: <FontAwesomeIcon icon={faArrowRight} />,
    downIcon: <FontAwesomeIcon icon={faArrowDown} />,
  },
  {
    heading: "Product",
    subHeading1: "Shopping Cart",
    subHeading2: "Product Detail",
    to1: "/cart",
    to2: "/productdetail",
    closeIcon: <FontAwesomeIcon icon={faArrowRight} />,
    downIcon: <FontAwesomeIcon icon={faArrowDown} />,
    className: "product",
  },
  {
    heading: "About",
    to1: "/about",
    className: "headingDrop",
  },
  {
    heading: "Contact",
    to1: "/contact",
    className: "headingDrop",
  },
];

export const NAVBAR = [
  {
    heading: "Home",
    active: "active",
    subHeading1: "Homepage 1",
    subHeading2: "Homepage 2",
    subHeading3: "Homepage 3",
    to1: "/homepage1",
    to2: "/homepage2",
    to3: "/homepage3",
    mainCategory: "home",
  },
  {
    heading: "Game Category",
    subHeading1: "Action & Adventure",
    subHeading2: "Sports",
    subHeading3: "Kids and Family",
    to1: "/adventure",
    to2: "/sports",
    to3: "/kids",
    category: "game",
  },
  {
    heading: "Blog",
    subHeading1: "Blog Left",
    subHeading2: "Blog Right",
    subHeading3: "Blog Full Width",
    subHeading4: "Blog Detail",
    to1: "/blogleft",
    to2: "/blogright",
    to3: "/blogfull",
    to4: "/blogdetail",
    category: "blog",
  },
  {
    heading: "Product",
    subHeading1: "Shopping Cart",
    subHeading2: "Product Detail",
    to1: "/cart",
    to2: "/productdetail",
    className: "product",
    category: "product",
  },
  {
    heading: "About",
    to1: "/about",
    className: "headingDrop",
    category: "about",
  },
  {
    heading: "Contact",
    to1: "/contact",
    className: "headingDrop",
    category: "contact",
  },
];
